// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"45":"dh-prosentvis-lottie","251":"dh-prosentvis-gltf"}[chunkId] || chunkId) + "-chunk-" + {"45":"39c81c994912e5d82d5e","251":"8802feed49ef736c3c75","630":"1e6b9fcd51097803cd14","834":"8c1a7f44efff218cc50f"}[chunkId] + ".js";
};